export const BaseCardBtnText: any = {
    us: {
        AddToCart: 'Add to Cart',
        BuyNow: 'Buy Now',
        LearnMore: 'Learn More',
        SoldOut: 'Sold Out',
        ComingSoon: 'Coming Soon',
        OFF: 'OFF',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Members only',
        ChooseYourPowerStation: 'Choose Your Power Station',
        All: 'All',
        pc: 'pc',
        pcs: 'pcs',
        ViewMore: 'View More',
        ViewLess: 'View Less',
        NonMemberPrice: '(Non-member price)',
    },
    de: {
        AddToCart: 'Zum Warenkorb hinzufügen',
        BuyNow: 'Jetzt kaufen',
        LearnMore: 'Mehr erfahren',
        SoldOut: 'Ausverkauft',
        ComingSoon: 'Demnächst erhältlich',
        OFF: 'Rabatt',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Nur für Mitglieder',
        ChooseYourPowerStation: 'Wählen Sie Ihre Powerstation',
        All: 'Alle',
        pc: 'Stk.',
        pcs: 'Stk.',
        ViewMore: 'Mehr anzeigen',
        ViewLess: 'Weniger anzeigen',
        NonMemberPrice: '(Preis für Nichtmitglieder)',
    },
    fr: {
        AddToCart: 'Ajouter au panier',
        BuyNow: 'Acheter',
        LearnMore: 'En savoir plus',
        SoldOut: 'Épuisé',
        ComingSoon: 'Bientôt disponible',
        OFF: 'Économisez',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Offre exclusive',
        ChooseYourPowerStation: 'Choisissez votre batterie solaire',
        All: 'Tout',
        pc: 'pièce',
        pcs: 'pièces',
        ViewMore: 'Afficher plus',
        ViewLess: 'Afficher moins',
        NonMemberPrice: '(Prix régulier)',
    },
    es: {
        AddToCart: 'Añadir al carrito',
        BuyNow: 'Comprar ahora',
        LearnMore: 'Más información',
        SoldOut: 'Agotado',
        ComingSoon: 'Próximamente',
        OFF: 'DESACTIVAR',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Solo miembros',
        ChooseYourPowerStation: 'Elige tu estación de energía',
        All: 'Todo',
        pc: 'ud.',
        pcs: 'uds',
        ViewMore: 'Ver más',
        ViewLess: 'Ver menos',
        NonMemberPrice: '(Precio no socio)',
    },
    it: {
        AddToCart: 'Aggiungi al carrello',
        BuyNow: 'Acquista ora',
        LearnMore: 'Scopri di più',
        SoldOut: 'Esaurito',
        ComingSoon: 'In arrivo',
        OFF: 'SCONTO',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Solo per i membri',
        ChooseYourPowerStation: 'Scegli la tua power station',
        All: 'Tutto',
        pc: 'pz.',
        pcs: 'pz.',
        ViewMore: 'Mostra di più',
        ViewLess: 'Mostra meno',
        NonMemberPrice: '(Prezzo per i non soci)',
    },
    jp: {
        AddToCart: 'カートに入れる',
        BuyNow: '今すぐ購入',
        LearnMore: '詳しくはこちら',
        SoldOut: '売り切れ',
        ComingSoon: 'まもなく公開',
        OFF: 'OFF',
        EcoCreditsX: '倍',
        EcoCreditsNum: 'エコポイント',
        MembersOnly: '会員限定',
        ChooseYourPowerStation: 'ポータブル電源を選択する',
        All: 'すべて',
        pc: '台/個',
        pcs: '台/個',
        ViewMore: 'さらに見る',
        ViewLess: '少なく表示する',
        priceEndTips: '（税込）',
        NonMemberPrice: '（非会員価格）',
    },
    kr: {
        AddToCart: '장바구니 담기',
        BuyNow: '바로 구매하기',
        LearnMore: '더 알아보기',
        SoldOut: '품절',
        ComingSoon: 'Sold Out',
        OFF: '할인',
        EcoCreditsX: '배',
        EcoCreditsNum: '에코포인트',
        MembersOnly: '회원 한정',
        ChooseYourPowerStation: '파워뱅크 선택하기',
        All: '전체',
        pc: '개',
        pcs: '개',
        ViewMore: '더 보기',
        ViewLess: '작게 보기',
        NonMemberPrice: '(비회원 가격)',
    },
    br: {
        AddToCart: 'Adicionar ao carrinho',
        BuyNow: 'Comprar agora',
        LearnMore: 'Saiba mais',
        SoldOut: 'Vendidos',
        ComingSoon: 'Em breve',
        OFF: 'OFF',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Exclusivo para membros',
        ChooseYourPowerStation: 'Escolha sua estação elétrica',
        All: 'Todos',
        pc: 'pc',
        pcs: 'pcs',
        ViewMore: 'Ver mais',
        ViewLess: 'Ver menos',
        NonMemberPrice: '(preço para não membros)',
    },
    mx: {
        AddToCart: 'Añadir al carrito',
        BuyNow: 'Comprar ahora',
        LearnMore: 'Más información',
        SoldOut: 'Agotado',
        ComingSoon: 'Agotado',
        OFF: 'OFF',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Solo miembros',
        ChooseYourPowerStation: 'Elige tu estación de energía',
        All: 'Todo',
        pc: 'unidad',
        pcs: 'unidades',
        ViewMore: 'Ver más',
        ViewLess: 'Ver menos',
        NonMemberPrice: '(Precio para no miembros)',
    },
    nl: {
        AddToCart: 'In winkelwagen',
        BuyNow: 'Nu kopen',
        LearnMore: 'Meer informatie',
        SoldOut: 'Uitverkocht',
        ComingSoon: 'Binnenkort beschikbaar',
        OFF: 'KORTING',
        EcoCreditsX: 'x',
        EcoCreditsNum: 'EcoCredits',
        MembersOnly: 'Alleen voor leden',
        ChooseYourPowerStation: 'Kies je powerstation',
        All: 'Alles',
        pc: 'stuk',
        pcs: 'stuks',
        ViewMore: 'Meer bekijken',
        ViewLess: 'Minder bekijken',
        NonMemberPrice: '(Prijs voor niet-leden)',
    },
};
